import React from 'react';
export var CheckoutContext = /*#__PURE__*/React.createContext({
  checkout: {},
  merchantId: null,
  locationId: null
});
export var CheckoutProvider = CheckoutContext.Provider;